// extracted by mini-css-extract-plugin
export default {"artCrop":"RelatedInfo_artCrop__UaYty","container":"RelatedInfo_container__BkxeJ","row":"RelatedInfo_row__4LelY","dark":"RelatedInfo_dark__Lbdvb"};